import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import { FontWeight } from 'design-system/variables/text';
import Imposter from 'images/dashboard/imposter.png';

const Container = styled.div`
  background-color: ${({ theme }) => theme.color.variants.caution.highlightLight};
  padding: ${Spacing[4]};
  display: flex;
  align-items: center;
  font-weight: ${FontWeight.Bold};
  overflow: hidden auto;
`;

const Image = styled.img`
  width: ${Spacing[7]};
`;

const TextContainer = styled.div`
  margin-left: ${Spacing[2]};
`;

const DangerText = styled.div`
  @keyframes warn {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 0.7;
    }
    100% {
      opacity: 0;
    }
  }
  color: red;
  animation-name: warn;
  animation-duration: 700ms;
  animation-iteration-count: infinite;
  animation-direction: alternate;
`;

interface FooterImpersonationProps {
  impersonationMode: string | undefined;
}

const FooterImpersonation = ({ impersonationMode }: FooterImpersonationProps) => {
  return impersonationMode ? (
    <Container data-test='impersonation-header'>
      <Image src={Imposter} />
      <TextContainer>
        Impersonating
        {'\n'}
        {impersonationMode === 'read_only' && '(Read only)'}
        {impersonationMode === 'full_control' && <DangerText>FULL CONTROL!!!</DangerText>}
      </TextContainer>
    </Container>
  ) : null;
};

export default FooterImpersonation;
